import request from '@/router/axios'

export function fetchCourseStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course',
    method: 'get',
    params,
  })
}

export function exportCourseStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course/export',
    method: 'get',
    params,
  })
}
